export default "__VITE_ASSET__C1_Rd3f0__"